import { atom, selector, selectorFamily } from 'recoil'
import { googlePlace } from 'src/atoms/search'
import { ZoneDetailArea, ZoneDetailResponse } from 'src/common-services/types/zone-types'
import { browserLogger } from 'src/utils/browser-logger'
import { keyFactory, retryAtom } from 'src/utils/recoil'
import { parcelsClient, zoneClient } from 'src/clients'
import { Position } from 'src/common-services'
import { PARCEL_COLORS_MAP } from 'src/constants/cherre-data-dictionary/zoning-colors'
import { Colors } from 'src/components/theme'

const key = keyFactory('zone')

export const zoningDetailsForPosition = selectorFamily<ZoneDetailResponse | undefined, Position>({
  key: key('zone-details-for-position'),
  get: (position) => async () => {
    const [lng, lat] = position
    try {
      const data = await zoneClient.getDetailByLocation(lat, lng)
      return data
    } catch (e) {
      browserLogger.error(e)
      return undefined
    }
  },
})

export const zoningDetailsForGooglePlace = selector<ZoneDetailResponse | undefined>({
  key: key('detail-location'),
  get: async ({ get }) => {
    get(retryAtom)
    const place = get(googlePlace)
    if (!place) {
      browserLogger.error('no place this should never happen')
      return undefined
    }
    const [lng, lat] = place.geometry.location
    return get(zoningDetailsForPosition([lng, lat]))
  },
})

export const zoningColor = selector<string | undefined>({
  key: key('zoning-color'),
  get: async ({ get }) => {
    const place = get(googlePlace)
    if (!place) {
      browserLogger.error('no place this should never happen')
      return undefined
    }
    const { mCode } = await parcelsClient.getMCodeByLatLng({
      lat: place.geometry.location[1],
      lng: place.geometry.location[0],
    })
    const zoningColor = PARCEL_COLORS_MAP.get(mCode) || Colors.textMedium
    return zoningColor
  },
})

export const zoningUsesSearch = atom<string>({
  key: key('zoning-uses-search'),
  default: '',
})

export const isMapStatic = atom<boolean>({
  key: key('is-map-static'),
  default: false,
})

export const areaLocation = selector<ZoneDetailArea | undefined>({
  key: key('area-location'),
  get: async ({ get }) => {
    get(retryAtom)
    const place = get(googlePlace)
    if (!place) {
      browserLogger.error('no place this should never happen')
      return undefined
    }
    const [lng, lat] = place.geometry.location
    try {
      const data = await zoneClient.getAreaByLocation(lat, lng)
      return data
    } catch (e) {
      browserLogger.error(e)
      return undefined
    }
  },
})
